export default "__VITE_ASSET__BYLCxbMI__"